<template>
    <footer class="footer">
      <div class="container" style="max-width:1000px">
        <div class="columns	">
          <div class="column has-text-left is-narrow">
            <ul>
              <li>
                <strong> Contact Us</strong>
              </li>
              <li>
                <a href="mailto:kirsten@joinfightcamp.com">
                  <i class="fas fa-envelope"></i> kirsten@joinfightcamp.com</a>
              </li>
              <li>
                <a href="tel:1-866-366-9202">
                  <i class="fas fa-phone"></i> (866) 366-9202</a>
              </li>
            </ul>
          </div>

          <div class="column is-1">
          </div>


          <div class="column has-text-left is-narrow">
            <ul>
              <li>
                <strong>Links</strong>
              </li>
              <li>
                <a href="https://joinfightcamp.com">FightCamp Website</a>
              </li>
              <li>
                <a href="https://joinfightcamp.com/pages/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="https://joinfightcamp.com/pages/legal-terms">Legal Terms</a>
              </li>
            </ul>
          </div>

          <div class="column is-1">
          </div>
          <div class="column has-text-left is-narrow">
            <ul>
              <li>
                <strong> Social Media</strong>
              </li>

              <li>
                <a href="https://www.instagram.com/fightcamp">
                  <i class="fab fa-instagram"></i> Instagram</a>
              </li>
              <li>
                <a href="https://www.facebook.com/fightcamp">
                  <i class="fab fa-facebook"></i> Facebook</a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCJ6J1r5u8CFsbyVZ03A6IaQ">
                  <i class="fab fa-youtube"></i> Youtube</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </footer>
</template>

<script>
  export default {
    name: 'Footer',

    props: ['content'],

    data: function () {
      return {

      }
    }
  }
</script>

<style scoped>
  a {
    color:#ff3860 !important
  }
</style>